import { useTranslation } from 'react-i18next';

import { Text } from '@/components/TextComponent';
import { Sport } from '@/feature/event-details-sbk/types';
import { getSectionTitleVariant } from '@/utils/sport-utils';

type Section = 'events' | 'lines';

const SECTION_TITLE_KEYS = {
    games: { events: 'common:games', lines: 'game_lines' },
    matchups: { events: 'matchups', lines: 'match_lines' },
} as const;

type LeagueSectionTitleProps = {
    sport: Sport | undefined;
    section: Section;
};

export const LeagueSectionTitle = ({ sport, section }: LeagueSectionTitleProps) => {
    const { t } = useTranslation(['lobby_sbk', 'common']);

    if (!sport) {
        return null;
    }

    return (
        <Text variant="headlineMedium" lineHeight={28} px="s16" mb="s12">
            {t(SECTION_TITLE_KEYS[getSectionTitleVariant(sport.name)][section])}
        </Text>
    );
};
